import { CircularProgress, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import React from "react";

function ActionCta({
  Image,
  text,
  onClick,
  containerClass,
  imageClass,
  isLoading,
}: {
  Image: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  text: string;
  containerClass?: string;
  imageClass?: string;
  onClick: () => void;
  isLoading?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      className={`hover:bg-[#F7F7F7] py-8 px-20 text-[#397EF5] ${containerClass}`}
    >
      {isLoading ? (
        <CircularProgress className="h-[14px] w-[14px] mr-8" />
      ) : (
        <Image className={`mr-10 h-20 w-20 ${imageClass}`} />
      )}
      <span className="font-semibold text-sm">{text}</span>
    </button>
  );
}

export default ActionCta;
